(function () {
  'use strict';
  var config = document.getElementById('htlShortFinderConfig');
  var modal = document.querySelector('#htlQuizModal[data-htl-short-finder]');
  if (!config || !modal) return;
  var settings = JSON.parse(config.textContent);
  if (settings.role !== 'main') return;
  var seen = new Set();
  var pending = [];
  var retries = 0;
  function permitted() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
    } catch (error) { return false; }
  }
  function flush() {
    if (!permitted() || typeof window.gtag !== 'function') return;
    while (pending.length) {
      var name = pending.shift();
      try { window.gtag('event', name, {finder_version:'fit_2026_10_19'}); } catch (error) {}
    }
  }
  function track(name, once) {
    if (!permitted() || (once && seen.has(name))) return;
    if (once) seen.add(name);
    pending.push(name);
    flush();
  }
  function wrap(name, after) {
    var original = window[name];
    if (typeof original !== 'function') return;
    window[name] = function () {
      var prior = modal.querySelector('.htl-quiz-screen.is-active');
      var result = original.apply(this, arguments);
      after(prior, arguments);
      return result;
    };
  }
  wrap('htlOpenQuiz', function () { track('htl_finder_start', true); });
  wrap('htlShowStep', function (prior, args) {
    if (prior && prior.getAttribute('data-step') === '0' && Number(args[0]) === 1) track('htl_finder_space_complete', true);
    if (prior && prior.getAttribute('data-step') === '1' && Number(args[0]) === 2) track('htl_finder_size_complete', true);
  });
  wrap('htlShowLead', function (prior) {
    var form = document.getElementById('htlLeadForm');
    if (!form || form.dataset.htlSubmitted === 'true') return;
    if (prior && prior.getAttribute('data-step') === '2' && prior.querySelector('.is-selected')) track('htl_finder_budget_complete', true);
    track('htl_finder_form_view', true);
  });
  wrap('htlRefineMatches', function () {
    if (document.getElementById('htlLeadForm').dataset.htlSubmitted === 'true') track('htl_finder_refine', true);
  });
  document.addEventListener('htl:lead-attempt', function (event) {
    if (event.target.id === 'htlLeadForm') track('htl_finder_submit_attempt', false);
  });
  document.addEventListener('htl:lead-error', function (event) {
    if (event.target.id === 'htlLeadForm') track('htl_finder_submit_error', false);
  });
  document.addEventListener('htl:finder-lead-confirmed', function (event) {
    if (event.target.id === 'htlLeadForm') track('htl_finder_enquiry_confirmed', true);
  });
  document.addEventListener('visitorConsentCollected', flush);
  if (modal.classList.contains('is-open')) track('htl_finder_start', true);
  (function retry() {
    flush();
    if (retries++ < 60) window.setTimeout(retry, 250);
  })();
})();


